import React from 'react';
import styled from 'App/styled';
import { hexToRgb } from '@nykaa/nes-ui-components/styles/utils';
import Modal from 'components/Modal';
import Cross from 'components/Icons/Cross';
import { ModalProps } from 'types/voiceSearch';
import { getVoiceText } from 'helpers/voiceSearch';
import MicroPhone from '../Microphone';
import ListenIcon from '../animation/Sound.gif';
import { API_ERROR, BLOCK_MICROPHONE, USER_INACTIVITY } from 'constants/voiceSearch';


const Wrapper = styled.div`
  padding: 16px 20px;
  height: 100%;
  position: relative;
  .microphone {
    border: 1px solid ${({ theme }) => hexToRgb(theme.brandPrimary, 0.1)};
    height: 56px;
    width: 56px;
    background: ${({ theme }) => hexToRgb(theme.brandPrimary, 0.1)};
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: static;
  }
`;
const CrossIcon = styled.button`
  border: none;
  display: flex;
  background: transparent;
  cursor: pointer
  position: relative;
  height: 40px;
  path {
    fill: rgba(0, 19, 37, 0.6);
  }
`;

const ListenGif = styled.img`
  width: 56px;
  height: 56px;
  background: #fff;
`;
const Icon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

// Replace with new token
const Text = styled.span`
  ${({ theme }) => theme.typography.type240};
  line-height: 32px;
  color: rgba(0, 19, 37, 0.48);
  opacity: 0.92;
  &.active {
    color: #001325;
  }
`;
const View = ({ status, voiceText, handleStart, handleCross }: ModalProps) => {
  const text = (voiceText) || (getVoiceText(status));
  const showMicrophone = ((status === USER_INACTIVITY) || (status === API_ERROR)) && !voiceText;
  const error = status === BLOCK_MICROPHONE;
  const activeClass = ((voiceText) || (showMicrophone) || (error)) ? 'active' : '';
  const handleMicrophone = () => {
    handleStart(false);
  };
  return (
    <Modal isBottomDrawer isVisible onHide={handleCross}>
      <Wrapper>
        <CrossIcon onClick={handleCross}>
          <Cross />
        </CrossIcon>
        <Text className={activeClass}>{text}</Text>
        <Icon>
          {(showMicrophone) && (
            <MicroPhone customClass="microphone" handleMicrophone={handleMicrophone} />
          )}
          {(!showMicrophone && !error) && <ListenGif src={ListenIcon} alt="Listen" />}
        </Icon>
      </Wrapper>
    </Modal>
  );
};

export default View;
